import React from 'react';
export function TermsOfService() {
  return <div className="py-12 bg-white" data-id="element-1253">
      <div className="container mx-auto px-4" data-id="element-1254">
        <div className="max-w-4xl mx-auto" data-id="element-1255">
          <div className="mb-8" data-id="element-1256">
            <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-1257">
              Terms of Service
            </h1>
            <p className="text-sm text-slate-500" data-id="element-1258">Last Updated: January 2025</p>
          </div>
          <div className="prose prose-slate max-w-none" data-id="element-1259">
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1260">
              1. Acceptance of Terms
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1261">
              By accessing and using Nura Health's services, you agree to be
              bound by these Terms of Service and all applicable laws and
              regulations. If you do not agree with any part of these terms,
              please do not use our services.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1262">
              Nura Health reserves the right to modify these terms at any time.
              Your continued use of our services following any changes
              constitutes acceptance of those changes. We will notify you of
              material changes by posting the updated terms on our website.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1263">
              2. Service Description
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1264">
              Nura Health provides medical tourism coordination services,
              including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1265">
              <li data-id="element-1266">Connecting patients with partner fertility clinics</li>
              <li data-id="element-1267">Coordinating appointments and treatment schedules</li>
              <li data-id="element-1268">Arranging travel and accommodation</li>
              <li data-id="element-1269">Providing translation and interpretation services</li>
              <li data-id="element-1270">Managing medical records transfer</li>
              <li data-id="element-1271">Administrative support throughout the treatment journey</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1272">
              Nura Health does not provide medical services, diagnosis, or
              treatment. All medical care is provided by independent partner
              clinics. We act solely as a coordination service.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1273">
              3. User Responsibilities
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1274">
              3.1 Accurate Information
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1275">
              You agree to provide accurate, current, and complete information
              during the registration and coordination process. You are
              responsible for maintaining the accuracy of this information.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1276">
              3.2 Medical Decisions
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1277">
              You acknowledge that all medical decisions are made between you
              and the healthcare providers at our partner clinics. Nura Health
              is not responsible for medical advice, treatment decisions, or
              outcomes.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1278">
              3.3 Compliance with Laws
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1279">
              You agree to comply with all applicable laws and regulations in
              your jurisdiction and the jurisdiction where you receive
              treatment.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1280">
              4. Payment Terms
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1281">
              4.1 Coordination Fees
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1282">
              Payment for coordination services is structured as follows:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1283">
              <li data-id="element-1284">
                30% initial deposit upon booking to secure services and begin
                coordination
              </li>
              <li data-id="element-1285">
                50% payment before travel arrangements are finalized and
                confirmed
              </li>
              <li data-id="element-1286">
                20% final payment due 7 days before scheduled treatment date
              </li>
            </ul>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1287">
              4.2 Medical Treatment Costs
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1288">
              Medical treatment costs are separate from coordination fees and
              are paid directly to partner clinics according to their payment
              terms and policies.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1289">
              4.3 Currency and Exchange Rates
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1290">
              All prices are quoted in the applicable currency. Exchange rate
              fluctuations may affect final costs. Nura Health is not
              responsible for currency exchange rate changes.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1291">
              5. Cancellation and Refund Policy
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1292">
              5.1 Cancellation by Client
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1293">
              If you need to cancel or reschedule your treatment:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1294">
              <li data-id="element-1295">
                Cancellations more than 30 days before scheduled treatment: 50%
                refund of coordination fees paid
              </li>
              <li data-id="element-1296">
                Cancellations 15-30 days before scheduled treatment: 25% refund
                of coordination fees paid
              </li>
              <li data-id="element-1297">
                Cancellations less than 15 days before scheduled treatment: No
                refund of coordination fees
              </li>
            </ul>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1298">
              5.2 Partner Clinic Cancellations
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1299">
              Partner clinic cancellation policies apply separately to medical
              treatment costs. Nura Health is not responsible for clinic
              cancellation fees or policies.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1300">
              5.3 Force Majeure
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1301">
              In cases of force majeure (including but not limited to natural
              disasters, pandemics, war, or government restrictions), we will
              work with you to reschedule services. Refund policies may be
              adjusted on a case-by-case basis.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1302">
              6. Limitation of Liability
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1303">
              To the maximum extent permitted by law, Nura Health shall not be
              liable for:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1304">
              <li data-id="element-1305">
                Medical outcomes, complications, or adverse events from
                treatment
              </li>
              <li data-id="element-1306">Actions, decisions, or negligence of partner clinics</li>
              <li data-id="element-1307">
                Travel delays, cancellations, or issues beyond our control
              </li>
              <li data-id="element-1308">
                Accommodation problems or issues with third-party service
                providers
              </li>
              <li data-id="element-1309">
                Changes in clinic policies, treatment availability, or pricing
              </li>
              <li data-id="element-1310">
                Loss or damage to personal property during travel or treatment
              </li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1311">
              Our total liability is limited to the coordination service fees
              paid by you.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1312">
              7. Indemnification
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1313">
              You agree to indemnify and hold harmless Nura Health, its
              officers, employees, and agents from any claims, damages, losses,
              or expenses arising from your use of our services or violation of
              these Terms of Service.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1314">
              8. Intellectual Property
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1315">
              All content on our website, including text, graphics, logos, and
              software, is the property of Nura Health and protected by
              intellectual property laws. You may not reproduce, distribute, or
              create derivative works without our written permission.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1316">
              9. Privacy and Data Protection
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1317">
              Your use of our services is also governed by our Privacy Policy.
              By using our services, you consent to the collection and use of
              your information as described in our Privacy Policy.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1318">
              10. Dispute Resolution
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1319">
              10.1 Governing Law
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1320">
              These Terms of Service are governed by the laws of the Czech
              Republic, without regard to its conflict of law provisions.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1321">
              10.2 Jurisdiction
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1322">
              Any disputes arising from these terms or our services shall be
              resolved in the courts of Prague, Czech Republic. You consent to
              the exclusive jurisdiction of these courts.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1323">
              10.3 Mediation
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1324">
              Before pursuing legal action, parties agree to attempt resolution
              through mediation in good faith.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1325">
              11. Severability
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1326">
              If any provision of these Terms of Service is found to be invalid
              or unenforceable, the remaining provisions shall remain in full
              force and effect.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1327">
              12. Entire Agreement
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1328">
              These Terms of Service, together with our Privacy Policy,
              constitute the entire agreement between you and Nura Health
              regarding our services.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1329">
              13. Contact Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1330">
              For questions about these Terms of Service, please contact us at:
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1331">
              Email: info@nurahealth.eu
              <br data-id="element-1332" />
              Address: [Company Address]
            </p>
          </div>
        </div>
      </div>
    </div>;
}